import { ILegalClient } from '../../../Interfaces/ILegalClient';
import { ILegalTransactionRelationshipMember } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipMember';

// WARN: None of these functions are used in the current codebase.

/**
 * Updates client names in the original array with data from the new array.
 * This is used to provide a live upload on the client names if they are updated.
 * @param originalArray The original array of legal clients to update
 * @param newArray The new array containing updated client information
 * @returns A new array with updated client names
 */
export const updateNames = (
  originalArray: ILegalTransactionRelationshipMember[],
  newArray: ILegalClient[]
): ILegalTransactionRelationshipMember[] => {
  const newMembersMap = new Map(
    newArray.map(member => [member.idLegalClient, member])
  );

  return originalArray.map(member => {
    const newMember = newMembersMap.get(member.idLegalClient);
    if (newMember) {
      return {
        ...member,
        FirstName: newMember.FirstName,
        LastName: newMember.LastName,
        LegalClient: {
          ...member.LegalClient,
          FirstName: newMember.FirstName,
          LastName: newMember.LastName,
        },
      };
    }
    return member;
  });
};
